'use strict';

require("core-js/modules/es.array.find");

require("core-js/modules/es.math.trunc");

var _ci = require('./ci.service');

var _ci2 = _interopRequireDefault(_ci);

require('./ci.styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

window.CIResponsive = _ci2.default;